<template>
    <div class="main-container">
        <!-- 页面标题 -->
        <div class="page-header">
            <h1 class="page-title">任务配置</h1>
        </div>
        <div class="content">
            <div>
                <form class="form-group-list-form">
                    <div class="form-group-list">
                        <div class="form-group">
                            <InputField labelWidth="30%" style="margin: 0.5rem 0.2rem;" label="任务名称" type="text" id="name"
                                        v-model="form.name" placeholder="请输入任务名称"
                                        ref="inputField1"
                                        @update:modelValue="(value) => handleModelValueUpdate('name', value)"
                            />
                        </div>
                        <div class="form-group">
                            <SelectField labelWidth="32%" label="类型" :options="typeList" v-model="form.type" id="type" placeholder="任务类型"
                                         ref="SelectField1"
                                         @update:modelValue="(value) => handleModelValueUpdate('type', value)"
                            />
                        </div>
                        <div class="form-group">
                            <SelectField labelWidth="32%" label="状态" :options="statusList" v-model="form.status" id="status" placeholder="任务状态"
                                         ref="SelectFieldS1"
                                         @update:modelValue="(value) => handleModelValueUpdate('status', value)"
                            />
                        </div>
                    <div class="form-group">
                        <a-space>
                            <ButtonField text="查询" @click="query" secondary />
                            <ButtonField text="重置" primary @click="reset"/>
                        </a-space>
                    </div>
            </div>
            <div>
                <ButtonField text="新建任务" @click="$router.push('/manage/map?page=temp&action=add')" secondary />
            </div>
                </form>
            </div>
            <div style="margin-top: 1rem;">
                <Tablelist
                    :showCheckbox="showCheckbox"
                    :list="list"
                    :columns="tableColumns"
                    :totalSize="totalSize"
                    :totalPages="totalPages"
                    :pageNum="pageNum"
                    :pageSize="pageSize"
                    @page-change="onChange"
                >
                    <template #template-type="{ item }">
                        <DataDictFinder dictType="taskType" :dictValue="item.type" />
                    </template>
                    <template #template-status="{ item }">
                        <DataDictFinder dictType="status" :dictValue="String(item.status)" />
                    </template>
                    <template v-slot:actions="{ item }">
                        <a-space>
                            <a href="#" @click.prevent="$router.push('/manage/map?page=temp&action=edit&id=' + item.id)">编辑</a>
                            <a href="#" class="danger" @click.prevent="deleteText(item)">删除</a>
                        </a-space>
                    </template>
                </Tablelist>
            </div>
        </div>
    </div>
</template>
<script>
import { fetchList, remove } from "../api/temp";
import { mapGetters } from "vuex";
import Tablelist from "@/components/water-affairs-style/table-list.vue";

export default {
    components: {Tablelist},
    data() {
        return {
            form: {},
            loading: false,
            totalSize: 0,
            totalPages: 0,
            pageNum: 1,
            pageSize: 10,
            list:[
                {number:1,name:'-',type:'-',exeMonths:'2025-03',exeWeek:'07',exeDate:'10',status:'reviewing'}
            ],
            showCheckbox:false,
            total: 0,
            tableColumns: [
                {
                    key: 'name',
                    title: '任务名称',
                    field: 'name',
                    infotype: 'text'
                },
                {
                    key: 'type',
                    title: '任务类型',
                    field: 'type',
                    infotype: 'template'
                },
                {
                    key: 'exeMonths',
                    title: '执行月份',
                    field: 'exeMonths',
                    infotype: 'text'
                },
                {
                    key: 'exeWeek',
                    title: '执行星期',
                    field: 'exeWeek',
                    infotype: 'text'
                },
                {
                    key: 'exeDate',
                    title: '执行日期',
                    field: 'exeDate',
                    ellipsis: true,
                    infotype: 'text'
                },
                {
                    key: 'status',
                    title: '状态',
                    field: 'status',
                    infotype: 'template'
                },
                {
                    key: 'actions',
                    title: '操作',
                    infotype: 'template'
                }
            ]
        };
    },

    computed: {
        ...mapGetters("setting", ["findDataDict"]),
        typeList() {
            return this.findDataDict("taskType");
        },
        statusList() {
            return this.findDataDict("status");
        },
    },

    mounted() {
        this.getList();
    },

    methods: {
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        getList() {
            this.loading = true;
            const { current, pageSize } = this;
            fetchList({
                pageNum: current,
                pageSize: pageSize,
                ...this.form,
            })
                .then((res) => {
                    if (Array.isArray(res.list)) {
                        this.list = Object.freeze(res.list);
                        this.totalSize = res.totalSize;
                        this.totalPages = res.totalPages;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        deleteText(text) {
            const that = this;
            this.$confirm({
                title: "确认要删除吗？",
                onOk() {
                    remove({ id: text.id }).then(() => {
                        that.getList();
                    });
                },
            });
        },
        onChange(pagination) {
            this.pageNum  = pagination;
            this.pageSize = 10;
            this.getList();
        },
        query() {
            this.pageNum = 1;
            this.pageSize = 10;
            this.getList();
        },
        reset() {
            this.form = {
                name: '',
                type: null,
                status: null,
            };
            this.$refs.inputField1.reset();
            this.$refs.SelectField1.reset();
            this.$refs.SelectFieldS1.reset();
            this.pageNum = 1;
            this.pageSize = 10;
            this.getList();
        },
    },
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
    background: #0a0e27;
    color: #fff;
    overflow-x: hidden;
}

/* 主内容区 */
.main-container {
    padding:2rem 0;
    width: 80%;
    margin: auto;
}

/* 页面标题 */
.page-header {
    margin-bottom: 2rem;
}

.page-title {
    font-size: 2rem;
    margin-bottom: 0.5rem;
    background: linear-gradient(135deg, #fff, #00ff96);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.content{
    background: rgba(20, 35, 70, 0.5);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 2rem;
    margin-bottom: 1.5rem;
}
.form-group-list-form{
    display: flex;
    justify-content: space-between;
}
.form-group-list{
    display: flex;
    justify-content: start;
}
.form-group {
    display: flex;
    align-items: center;
    margin-right: 1rem;
}
</style>